import { createInertiaApp, router } from '@inertiajs/svelte'
import Layout from '~/Layout.svelte'
import { mount } from 'svelte'

import "~/i18n"

// Error tracking (roadmap P0-C). The DSN arrives in a meta tag rendered by
// the layout, not through import.meta.env — a build-time value would mean
// rebuilding the image to change it, and a browser DSN is public anyway.
// Dynamic import so the SDK is a separate chunk that never loads when the tag
// is absent; a blocked or failed load is silently ignored — error tracking
// must never affect the app.
const sentryDsn = document.querySelector('meta[name="sentry-dsn"]')?.content;
if (sentryDsn) {
    import('@sentry/browser')
        .then(Sentry => Sentry.init({
            dsn: sentryDsn,
            sendDefaultPii: false,
            // Strip query strings (?q= carries search terms) before sending.
            beforeSend(event) {
                if (event.request?.url) event.request.url = event.request.url.split('?')[0];
                return event;
            },
        }))
        .catch(() => {});
}

createInertiaApp({
    resolve: async name => {
        const pages = import.meta.glob('../pages/**/*.svelte')
        const page = await pages[`../pages/${name}.svelte`]()
        return { default: page.default, layout: page.layout || Layout };
    },
    setup({ el, App, props }) {
        mount(App, { target: el, props })
        router.on('navigate', () => window.uwuboxTrackPageView?.())
    },
})
